
import Header from "./Components/Header";
import Footer from "./Components/Footer";

function Layout(props) {
    return (
        <>
            <Header />

             <main>{props.children}</main>

            <Footer />
        </>
    );
}

export default Layout;